import React from 'react';
import styled from 'styled-components';
import { Popup, Select, Tag } from 'tdesign-react';

/**
 * @typedef {import("./type").Props} Props
 */

/**
 * * Select 多选下拉框兼容扩展，当选项数量超出时，可通过折叠展开来收起
 * 封装折叠内容可删除（TD 1.7.1版本前，没有提供collapsedItems onClose方法, 借用onChange处理）
 * @param {Props} props
 * @returns
 */
export default function SelectCollapsed({ minCollapsedNum = 5, onChange, value, ...others }) {
  return (
    <Select
      placeholder='请选择'
      multiple
      value={value}
      filterable
      minCollapsedNum={minCollapsedNum}
      collapsedItems={({ collapsedSelectedItems }) => (
        <Popup
          key={'tags'}
          overlayInnerStyle={{
            padding: '5px',
          }}
          content={
            <CollapsedItemsPopWrapper>
              {collapsedSelectedItems.map((item, index) => (
                <Tag
                  key={index}
                  closable
                  onClose={() => onChange(value?.filter((_, i) => i !== minCollapsedNum + index))}
                >
                  {item}
                </Tag>
              ))}
            </CollapsedItemsPopWrapper>
          }
        >
          <Tag>更多 ({collapsedSelectedItems?.length})</Tag>
        </Popup>
      )}
      onChange={onChange}
      {...others}
    />
  );
}

const CollapsedItemsPopWrapper = styled.div`
  max-width: 550px;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;
